// Import
import React from "react"
import { DeviceFrame } from "@molecules"

export const CollapseContent = ({ data, selectedIndex }) => {
  return (
    <div className="collapse">
      {data.map((elem, index) => {
        return (
          <div
            key={index}
            className={`collapse-content ${
              selectedIndex === index ? "active" : ""
            }`}
          >
            <DeviceFrame fit key={index}>
              <video
                className="child"
                poster={elem.contentPoster.url}
                autoPlay
                muted
                loop
                playsInline
              >
                <source src={elem.content.url} type="video/mp4" />
              </video>
            </DeviceFrame>
          </div>
        )
      })}
    </div>
  )
}
